module.exports = __webpack_public_path__ + "cd91a986569ae955e638abe84c024309.svg";